import base from "../baseurl";
import token from "../getTk";

const Create = async (uuid) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("votes/showall", {
      json: {
        electionUuid: uuid,
      },
    })
    .json();
    //console.log(Create)

  return Create;
};

export default Create;
